import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SocialAuthService from '../../services/SocialAuthService';
import { toast } from 'react-toastify';

const SocialLogin = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleProviderLogin = async (provider) => {
    try {
      setLoading(true);
      const url = await SocialAuthService.getRedirectUrl(provider);
      window.location.href = url;
    } catch (error) {
      onError?.(error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  return (
    <div className="social-login-container">
      <div className="row w-100 gy-3">
        <div className="col-md-12">
          <button className="social-btn" onClick={() => handleProviderLogin('google')}>
            <img src="/images/google.png" alt="Google icon" />
            <span>Login with Google</span>
          </button>
        </div>
      </div>
      {loading && <div className="loading-overlay">Loading...</div>}
    </div>
  );
};

export default SocialLogin; 